import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const tickerItems = [
  { type: 'price', symbol: 'BTC',  price: '$95,420', change: '+2.3%',  up: true  },
  { type: 'news',  text: 'بيتكوين يتجاوز مقاومة ٩٥,٠٠٠ دولار — إشارة صعودية قوية' },
  { type: 'price', symbol: 'ETH',  price: '$3,240',  change: '-0.8%',  up: false },
  { type: 'news',  text: 'Ethereum accumulation pattern detected — bullish signal from QuidPulse' },
  { type: 'price', symbol: 'SOL',  price: '$185',    change: '+4.1%',  up: true  },
  { type: 'news',  text: 'تحليل: نموذج دعم قوي على إيثريوم عند ٣,٢٠٠ دولار' },
  { type: 'price', symbol: 'BNB',  price: '$485',    change: '-1.2%',  up: false },
  { type: 'news',  text: 'BTC dominance rises to 54.2% — altcoin pressure persists' },
  { type: 'price', symbol: 'AVAX', price: '$42.5',   change: '+3.7%',  up: true  },
  { type: 'news',  text: 'ارتفاع حجم التداول على منصات ديفاي اللامركزية بنسبة ١٨٪' },
  { type: 'price', symbol: 'ADA',  price: '$0.68',   change: '+1.5%',  up: true  },
  { type: 'news',  text: 'Market structure remains broadly bullish — weekly intelligence report' },
  { type: 'price', symbol: 'DOT',  price: '$8.90',   change: '+0.9%',  up: true  },
  { type: 'news',  text: 'إشارة: كسر مستوى ٩٠,٠٠٠ دولار يؤكد الاتجاه الصعودي للبيتكوين' },
  { type: 'price', symbol: 'LINK', price: '$18.30',  change: '+2.8%',  up: true  },
  { type: 'news',  text: 'Institutional inflows reach highest level since 2021 — Quidanalyzer report' },
];

// Duplicate for seamless infinite loop
const allItems = [...tickerItems, ...tickerItems];

const IntelligenceTicker = () => {
  const { language, isRTL } = useLanguage();
  const isAr = language === 'ar';
  const [paused, setPaused] = useState(false);

  // Fade gradients respect the document direction
  const startFade = isRTL
    ? 'linear-gradient(to left, hsl(var(--card)) 75%, transparent)'
    : 'linear-gradient(to right, hsl(var(--card)) 75%, transparent)';
  const endFade = isRTL
    ? 'linear-gradient(to right, hsl(var(--card)) 40%, transparent)'
    : 'linear-gradient(to left, hsl(var(--card)) 40%, transparent)';

  return (
    <div
      data-testid="intelligence-ticker"
      className="relative overflow-hidden border-y border-border bg-card"
      style={{ height: '38px' }}
    >
      {/* LIVE badge — start side, mirrors in RTL */}
      <div
        className="absolute top-0 bottom-0 z-10 flex items-center bg-card pe-6 ps-4 start-0"
        style={{ background: startFade }}
      >
        <div className="flex items-center gap-1.5 shrink-0">
          <span
            className="h-1.5 w-1.5 rounded-full bg-gold animate-pulse shrink-0"
            style={{ animationDuration: '1.5s' }}
          />
          <span className="text-[11px] font-semibold text-gold tracking-wider uppercase">
            {isAr ? 'مباشر' : 'LIVE'}
          </span>
          <span className="text-border mx-1.5 text-xs">|</span>
        </div>
      </div>

      {/* Scrolling track */}
      <div
        className="flex items-center h-full"
        style={{
          paddingInlineStart: '90px',
          width: 'max-content',
          animation: `${isRTL ? 'ticker-scroll-rtl' : 'ticker-scroll'} 60s linear infinite`,
          animationPlayState: paused ? 'paused' : 'running',
        }}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        {allItems.map((item, i) => (
          <span key={i} className="flex items-center shrink-0 px-3">
            {item.type === 'price' ? (
              <span className="flex items-center gap-1.5 text-[11px]" dir="ltr">
                <span className="font-bold text-foreground">{item.symbol}</span>
                <span className="text-muted-foreground">{item.price}</span>
                <span className={`font-semibold ${item.up ? 'text-emerald-400' : 'text-red-400'}`}>
                  {item.change}
                </span>
              </span>
            ) : (
              <span className="text-[11px] text-muted-foreground/80 max-w-xs truncate">
                {item.text}
              </span>
            )}
            <span className="text-border/50 ms-3 text-xs">·</span>
          </span>
        ))}
      </div>

      {/* End-side fade */}
      <div
        className="absolute top-0 bottom-0 w-16 pointer-events-none end-0"
        style={{ background: endFade }}
      />
    </div>
  );
};

export default IntelligenceTicker;
